export default "__VITE_ASSET__CcpRUJah__"